module.exports = __webpack_public_path__ + "img/in.f3a60ba3.svg";